export class ContenutoGenerico {
    public uuid: string;
    public sottotitolo: string;
    public slug: string; // è usato come sottotitolo
    public nomePadre: string; // è usato come sottotitolo
    public titolo: string;
    public keywords: string;
    public anteprima: string;
    public testo: string;
    public pagina: string;
    public posizione: string;
    public immagine: string;
    public contenitore: string;
    public template: string;
    public path_immagine: string;
    public ordine: number; // orderBy
    public lang: string;

    constructor() {

    }
}
